import script from "./Unauthorised.vue?vue&type=script&setup=true&lang=ts"
export * from "./Unauthorised.vue?vue&type=script&setup=true&lang=ts"

import "./Unauthorised.vue?vue&type=style&index=0&id=334e3e8b&lang=css"

const __exports__ = script;

export default __exports__